import React from "react";
import ReactDOM from "react-dom";
import { HashRouter } from "react-router-dom";
import App from "./app";
import jquery from "jquery";
import metismenu from "metismenu";
ReactDOM.render(<App />, document.getElementById("root"));
